(async () => {
    const { Core } = await importModule('Core');

    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';
    
    customElements.define('product-to-cart', class extends Core {
        elements = {
            button: '[data-to-cart]'
        }
        
        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':  '_cartUpdateHandler'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this._handleClick()
        }

        _handleClick() {
            this.addEventListener('click', this._onClick.bind(this))
        }

        _onClick() {
            this.loading = true;
            !this.belongsToForm && this.addToCart(this.cartItem);
        }
 
        addToCart(items,mainVariantId) {
            mainVariantId = mainVariantId || this.variantId;

            if (mainVariantId == 49544368718139 || mainVariantId == 49544368816443) {
                items.map((item)=>{
                    if (item.id == mainVariantId) {
                        item.properties = {
                            __is_bundle:`__is_bunlde-${mainVariantId}`
                        }
                    }
                })
                items.push({
                    id:'49544343814459',
                    quantity:1,
                    properties:{
                        __is_bundle:`__is_bunlde-${mainVariantId}`
                    },
                    selling_plan:document.querySelector('.composter-bundle-sellong_plan')?.dataset?.id || '9069723963'
                })
            }else if (mainVariantId == 49544368750907 || mainVariantId == 49544368849211) {
                items.map((item)=>{
                    if (item.id == mainVariantId) {
                        item.properties = {
                            __is_bundle:`__is_bunlde-${mainVariantId}`
                        }
                    }
                })
                items.push({
                    id:'49544343847227',
                    quantity:1,
                    properties:{
                        __is_bundle:`__is_bunlde-${mainVariantId}`
                    },
                    selling_plan:document.querySelector('.composter-bundle-sellong_plan')?.dataset?.id || '9070313787'
                })
            }
            this.publish('cart:add', {
                items
            });
        }

        _cartUpdateHandler() {
            setTimeout(() => {
                this.loading = false
            }, 1500)
        }

        get belongsToForm() {
            return this.hasAttribute(ATTR_BELONGS_FORM)
        }

        get cartItem() {
            return [{ 
                id: +this.getAttribute(ATTR_VARIANT_ID), 
                quantity: 1,
                selling_plan:this.getAttribute('data-selling-plan'),
                properties:{
                    '_is_fullfillDate':this.getAttribute('data-fulfill-date')
                }
            }]
        }
        
        set loading(state) {
            this.$button.classList.toggle(CN_LOADING, state);
        }

        get cartNotificationsEnabled() {
            return window.global.cartNotificationsEnabled;
        }

        set variantId(id) {
            this.setAttribute(ATTR_VARIANT_ID, id)
        }

        set sellingPlan(id) {
            this.setAttribute('data-selling-plan', id)
        }

        get variantId() {
            return this.getAttribute(ATTR_VARIANT_ID)
        }

    })
})();